import './main.scss';
import logo from '../../assets/onepay.png';
import secure from '../../assets/secure.png';
import { getAvailablePaymentTypes, pay_types } from '../../utils/payment_types';
import { optionType } from '../../types/pages.types';
import { useEffect, useState, useCallback } from 'react';
import { CardPayments } from '../../components/CardPayments/CardPayments';
import { BsArrowLeft } from 'react-icons/bs';
import { GetTransactionDataAPI } from '../../services/verifications.service';
import { useNavigate, useParams } from 'react-router-dom';
import { TransactionDetails, notifyDetails } from '../../types/api.types';
import { useDispatch, useSelector } from 'react-redux';
import { setPaymentDetails } from '../../redux/paymentActions';
import TransactionListener, {
  insertTransactionData,
} from '../../configs/firebaseConfig';
import success from '../../assets/success.png';
import fail from '../../assets/fail.png';
import { Frimi } from '../../components/Frimi/Frimi';
import { Vishwa } from '../../components/Vishwa/Vishwa';
import { useFadeIn } from '../../hooks/fade_hook';
import { Loader } from '../Loader/Loader';
import { getJsonHash } from '../../utils/hashing.utils';
import { LankaQR } from '../../components/LankaQR/LankaQr';
import { HelaPay } from '../../components/HelaPay/HelaPay';
import { Qplus } from '../../components/QPlus/Qplus';
import { date } from 'yup';

export const Main = () => {
  const fadeIn = useFadeIn(0); // Adjust the delay as needed (in milliseconds)
  const successDetail: notifyDetails = useSelector(
    (state: any) => state.notify
  );
  const paymentDetails: TransactionDetails = useSelector(
    (state: any) => state.payment
  );
  const installmentData = useSelector((state: any) => state.installment);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { appid, gateway_id, hash } = useParams();
  const [selectedOption, setSelectedOption] = useState<optionType | null>();
  const [transactionData, setTransactionData] = useState<TransactionDetails>();
  const [isSucess, setIsSuccess] = useState<boolean>(false);
  const [isFail, setIsFail] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [cardPaymentStep, setCardPaymentStep] = useState<string>('root');
  const [cardPaymentData, setCardPaymentData] = useState<any>({});
  console.log(transactionData);
  function postRedirect(url: string, payload: any) {
    // Create a form element
    const form = document.createElement('form');

    // Set the form's method and action attributes
    form.method = 'POST';
    form.action = url;

    // Loop through the payload and create hidden input fields
    for (const key in payload) {
      if (payload.hasOwnProperty(key)) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = payload[key];
        form.appendChild(input);
      }
    }

    // Append the form to the body
    document.body.appendChild(form);

    // Submit the form
    form.submit();
  }

  function getFormattedDateTime() {
    const date = new Date();

    // Get components
    const year = date.getFullYear();
    // Months are zero-indexed, so add 1
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    // Construct the date-time string
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  useEffect(() => {
    getTransactionData();
  }, []);

useEffect(() => {

    if (
      successDetail &&
      successDetail.is_pay === true &&
      transactionData?.data.transaction_redirect_url
    ) {
      const iframeContainer = document.getElementById('hp-qrcontainer');
      if (iframeContainer) {
        iframeContainer.innerHTML = ''; // Clear the iframe content
      }

      const transactionDetails = {
        is_pay: true, // Set the value accordingly
        merchant_transaction_id: transactionData.data.request_transaction_id,
        tran_date: getFormattedDateTime(),
      };
      insertTransactionData(
        transactionData.data.onepay_transaction_id,
        transactionDetails
      );
      const timer = setTimeout(() => {
        if (transactionData.data.is_sdk) {
          let hash_request = {
            onepay_transaction_id: transactionData.data.onepay_transaction_id,
            merchant_transaction_id:
              transactionData.data.request_transaction_id,
            status: 1,
          };

          let redirect_request = {
            ...hash_request,
            hash: getJsonHash(hash_request),
          };
          postRedirect(
            transactionData.data.transaction_redirect_url,
            redirect_request
          );
        } else {
          try {
            const parentUrl = window.parent.location.href;
            console.log('Parent URL:', parentUrl);

            if (
              parentUrl !==
              (process.env.REACT_APP_PAYMENT_ONEPAY_URL ||
                'https://payment.onepay.lk')
            ) {
              console.log('Parent URL is different.');
            } else {
              console.log('Parent URL matches the expected one.');
            }
          } catch (e) {
            console.log(
              'Cannot access parent URL due to cross-origin restrictions.'
            );
          }

          window.location.href = transactionData?.data.transaction_redirect_url;
        }
      }, 5000); // 5000 milliseconds = 5 seconds

      // Clear timeout if the component unmounts or successDetail changes
      return () => clearTimeout(timer);
    } else if (
      successDetail &&
      successDetail.is_pay === false &&
      successDetail.is_authenticated==true && 
      transactionData?.data.transaction_redirect_url

    ) {
      const iframeContainer = document.getElementById('hp-qrcontainer');
      if (iframeContainer) {
        iframeContainer.innerHTML = ''; // Clear the iframe content
      }

      const transactionDetails = {
        is_pay: false, // Set the value accordingly
        merchant_transaction_id: transactionData.data.request_transaction_id,
        tran_date: getFormattedDateTime(),
      };
      insertTransactionData(
        transactionData.data.onepay_transaction_id,
        transactionDetails
      );

      const timer = setTimeout(() => {
        if (transactionData.data.request_type === 'SDK') {
          let hash_request = {
            onepay_transaction_id: transactionData.data.onepay_transaction_id,
            merchant_transaction_id:
              transactionData.data.request_transaction_id,
            status: 0,
          };

          let redirect_request = {
            ...hash_request,
            hash: getJsonHash(hash_request),
          };
          postRedirect(
            transactionData.data.transaction_redirect_url,
            redirect_request
          );
        } else {
          window.location.href = transactionData?.data.transaction_redirect_url;
        }
      }, 5000); // 5000 milliseconds = 5 seconds

      // Clear timeout if the component unmounts or successDetail changes
      return () => clearTimeout(timer);
    }
  }, [successDetail, transactionData]);

  const getTransactionData = async () => {
    try {
      setIsLoading(true);
      const api_response: any = await GetTransactionDataAPI(
        gateway_id ? gateway_id : ''
      );
      console.log(api_response);
      if (api_response && api_response.status != 2) {
        setTransactionData(api_response);
        dispatch(setPaymentDetails(api_response));
        setIsLoading(false);
      } else {
        navigate('/unauth');
      }
    } catch (e) {}
  };

  const optionClick = (types: optionType) => {
    setSelectedOption(types);
    // Reset card payment step when selecting payment method
    setCardPaymentStep('root');
    setCardPaymentData({});
  };

  const handleCardPaymentStepChange = useCallback(
    (step: string, data?: any) => {
      setCardPaymentStep(step);
      setCardPaymentData(data || {});
    },
    []
  );

  const handleBackNavigation = useCallback(() => {
    if (
      selectedOption?.type === 'Bank Credit/Debit' &&
      cardPaymentStep !== 'root'
    ) {
      // Handle card payment step-by-step back navigation
      const backHandler = (window as any).cardPaymentBackHandler;
      if (backHandler && backHandler()) {
        return true; // Navigation handled by card payment flow
      }
    }

    // Default behavior - go back to main payment selection
    setSelectedOption(null);
    setCardPaymentStep('root');
    setCardPaymentData({});
    return true;
  }, [selectedOption?.type, cardPaymentStep]);

  const getBackButtonText = () => {
    if (selectedOption?.type === 'Bank Credit/Debit') {
      switch (cardPaymentStep) {
        case 'plan-selected':
          return 'Back to Plan Selection';
        case 'bank-selected':
          return 'Back to Bank Selection';
        case 'payment-type-selected':
          return 'Back to Payment Options';
        default:
          return selectedOption.type;
      }
    }
    return selectedOption?.type || '';
  };

  const serviceValidation = (
    arr1: Array<{ id: number; key: string }> | Array<string>,
    arr2: Array<string>
  ) => {
    // Handle both old format (array of strings) and new format (array of objects)
    const providerKeys =
      Array.isArray(arr1) && arr1.length > 0 && typeof arr1[0] === 'object'
        ? arr1.map((item: any) => item.key)
        : (arr1 as Array<string>);

    return providerKeys.some((item1: string) =>
      arr2.some((item2) => item1.includes(item2))
    );
  };

  const redirectToShopify = () => {
    // Note: Shopify integration may need to be updated based on new data structure
    let url =
      (process.env.REACT_APP_SHOPIFY_VOID_SESSION_URL ||
        'https://shpy-onepay-dot-spemai-global.uc.r.appspot.com/app/void_session/') +
      '?shop=' +
      'shop_name' + // This property is not available in new structure
      '&access_token=' +
      'access_token' + // This property is not available in new structure
      '&cancel_url=' +
      transactionData?.data.app.redirection_url +
      '&id=' +
      transactionData?.data.request_transaction_id;
    var redirect_req = {
      id: transactionData?.data.request_transaction_id,
      gid: transactionData?.data.request_transaction_id,
      paymentId: transactionData?.data.request_transaction_id,
      proposedAt: new Date().toUTCString,
    };
    postRedirect(url, redirect_req);
  };

  return (
    <div
      className={`main-container ${
        fadeIn ? 'fade-enter-active' : 'fade-enter'
      }`}
    >
      {isLoading && <Loader />}
      <TransactionListener
        transactionId={transactionData?.data.onepay_transaction_id ?? ''}
      />
      {!isLoading && (
        <>
          {' '}
          {successDetail.transaction_id === '' && (
            <div className="gateway-container">
              <div
                className="gateway-details p-3"
                style={{
                  backgroundColor:
                    transactionData?.data.app.banner_bg_color &&
                    transactionData?.data.app.banner_bg_color.includes('#')
                      ? transactionData?.data.app.banner_bg_color
                      : `#${transactionData?.data.app.banner_bg_color}`,
                }}
              >
                <div className="row mb-3">
                  <div className="col-6">
                    <img
                      className="logo-style"
                      src={
                        transactionData?.data.app.brand_logo
                          ? (process.env.REACT_APP_STORAGE_BASE_URL ||
                              'https://storage.googleapis.com/onepay_ipg/') +
                            transactionData?.data.app.brand_logo
                          : logo
                      }
                      alt={'logo'}
                    />
                  </div>
                  <div className="col-6">
                    <div
                      className="detail-txt pb-2"
                      style={{
                        color:
                          transactionData?.data.app.banner_font_color &&
                          transactionData?.data.app.banner_font_color.includes(
                            '#'
                          )
                            ? transactionData?.data.app.banner_font_color
                            : `#${transactionData?.data.app.banner_font_color}`,
                      }}
                    >
                      {cardPaymentStep === 'plan-selected'
                        ? 'Monthly Payment'
                        : 'Total Payable'}
                      {transactionData?.data.shopify &&
                        Object.keys(transactionData.data.shopify).length >
                          0 && (
                          <button
                            onClick={() =>
                              (window.location.href =
                                transactionData?.data.shopify.cancel_url)
                            }
                            className="badge badge-danger ms-4"
                          >
                            Cancel
                          </button>
                        )}
                    </div>
                    <div
                      className="detail-value"
                      style={{
                        color:
                          transactionData?.data.app.banner_font_color &&
                          transactionData?.data.app.banner_font_color.includes(
                            '#'
                          )
                            ? transactionData?.data.app.banner_font_color
                            : `#${transactionData?.data.app.banner_font_color}`,
                      }}
                    >
                      {transactionData?.data.currency} :{' '}
                      {Number(transactionData?.data.request_amount).toFixed(2)}
                    </div>
                    {cardPaymentStep === 'plan-selected' &&
                      cardPaymentData?.selectedPlan && (
                        <div
                          className="detail-txt"
                          style={{
                            color:
                              transactionData?.data.app.banner_font_color &&
                              transactionData?.data.app.banner_font_color.includes(
                                '#'
                              )
                                ? transactionData?.data.app.banner_font_color
                                : `#${transactionData?.data.app.banner_font_color}`,
                            fontSize: '12px',
                            marginTop: '4px',
                          }}
                        >
                          ({cardPaymentData.period || ''} x{' '}
                          {transactionData?.data.currency}{' '}
                          {Number(
                            paymentDetails?.data?.request_amount || 0
                          ).toFixed(2)}
                          )
                        </div>
                      )}
                    {paymentDetails?.data?.discount_applied && (
                      <div
                        className="detail-txt"
                        style={{
                          color:
                            transactionData?.data.app.banner_font_color &&
                            transactionData?.data.app.banner_font_color.includes(
                              '#'
                            )
                              ? transactionData?.data.app.banner_font_color
                              : `#${transactionData?.data.app.banner_font_color}`,
                          fontSize: '12px',
                          marginTop: '4px',
                          fontWeight: '500',
                        }}
                      >
                        {
                          paymentDetails.data.discount_applied
                            .discount_percentage
                        }
                        % off: {transactionData?.data.currency}{' '}
                        {Number(
                          paymentDetails.data.discount_applied.discounted_amount
                        ).toFixed(2)}
                      </div>
                    )}
                  </div>
                </div>
                <div className="details-border mb-2"></div>
                <div className="row">
                  <div className="col-6">
                    <div
                      className="detail-txt pb-2"
                      style={{
                        color:
                          transactionData?.data.app.banner_font_color &&
                          transactionData?.data.app.banner_font_color.includes(
                            '#'
                          )
                            ? transactionData?.data.app.banner_font_color
                            : `#${transactionData?.data.app.banner_font_color}`,
                      }}
                    >
                      Merchant Name
                    </div>
                    <div
                      className="detail-value"
                      style={{
                        color:
                          transactionData?.data.app.banner_font_color &&
                          transactionData?.data.app.banner_font_color.includes(
                            '#'
                          )
                            ? transactionData?.data.app.banner_font_color
                            : `#${transactionData?.data.app.banner_font_color}`,
                      }}
                    >
                      {transactionData?.data.merchant.business_name}
                    </div>
                  </div>
                  <div className="col-6">
                    <div
                      className="detail-txt pb-2"
                      style={{
                        color:
                          transactionData?.data.app.banner_font_color &&
                          transactionData?.data.app.banner_font_color.includes(
                            '#'
                          )
                            ? transactionData?.data.app.banner_font_color
                            : `#${transactionData?.data.app.banner_font_color}`,
                      }}
                    >
                      Brand Name
                    </div>
                    <div
                      className="detail-value"
                      style={{
                        color:
                          transactionData?.data.app.banner_font_color &&
                          transactionData?.data.app.banner_font_color.includes(
                            '#'
                          )
                            ? transactionData?.data.app.banner_font_color
                            : `#${transactionData?.data.app.banner_font_color}`,
                      }}
                    >
                      {transactionData?.data.app.app_name}
                    </div>
                  </div>
                </div>
              </div>
              <div className="gateway-bottom d-flex align-items-end">
                <div className="gateway-block">
                  <div className="d-flex justify-content-between p-3">
                    {!selectedOption?.type && (
                      <div className="p-method">Select Payment Method</div>
                    )}
                    {selectedOption?.type && (
                      <div
                        style={{ cursor: 'pointer' }}
                        className="p-method d-flex"
                        onClick={handleBackNavigation}
                      >
                        <BsArrowLeft className="me-2" />
                        {getBackButtonText()}
                      </div>
                    )}

                    <div>
                      <img className="s-img" src={secure} alt="secure" />
                    </div>
                  </div>
                  {!selectedOption?.type && (
                    <div>
                      {getAvailablePaymentTypes(
                        transactionData?.data.request_amount
                      ) &&
                        getAvailablePaymentTypes(
                          transactionData?.data.request_amount
                        ).map((type: optionType, index: number) =>
                          serviceValidation(
                            transactionData?.data.provider_keys ?? [],
                            type.services
                          ) ? (
                            <div onClick={() => optionClick(type)} key={index}>
                              <div
                                className={`row p-3 type-tile ${
                                  selectedOption?.type === type.type
                                    ? 'type-active'
                                    : ''
                                }`}
                              >
                                <div className="col-6 text-start type-txt d-flex align-items-center">
                                  {type.type}
                                </div>
                                <div className="col-6 d-flex justify-content-end">
                                  {type.image}
                                  {/* <img src={type.image} alt={type.type} /> */}
                                </div>
                              </div>
                            </div>
                          ) : (
                            <></>
                          )
                        )}
                    </div>
                  )}

                  {selectedOption?.type === 'Bank Credit/Debit' && (
                    <div>
                      <CardPayments
                        onStepChange={handleCardPaymentStepChange}
                        onBackNavigation={handleBackNavigation}
                      />
                    </div>
                  )}

                  {selectedOption?.type === 'FriMi' && (
                    <div>
                      <Frimi />
                    </div>
                  )}

                  {selectedOption?.type === 'Sampath Vishwa' && (
                    <div>
                      <Vishwa />
                    </div>
                  )}

                  {selectedOption?.type === 'Lanka QR' && (
                    <div>
                      <LankaQR />
                    </div>
                  )}

                  {selectedOption?.type === 'Hela Pay' && (
                    <div>
                      <HelaPay />
                    </div>
                  )}

                  {selectedOption?.type === 'Combank Q+' && (
                    <div>
                      <Qplus />
                    </div>
                  )}
                </div>
                <div className="d-flex justify-content-center w-100 pay-footer">
                  <p className="mb-1">
                    © 2025 Copyright by OnePay. All rights reserved.
                  </p>
                </div>
              </div>
            </div>
          )}
          {successDetail &&
            successDetail.is_pay &&
            successDetail.transaction_id !== '' && (
              <div className="gateway-container2 p-5 d-flex align-items-center">
                <div>
                  <div className="d-flex justify-content-center">
                    <img src={success} alt="success" />
                  </div>
                  <div className="success-txt">
                    Payment completed successfully..!
                  </div>
                  <div className="success-amt">
                    {paymentDetails?.data?.discount_applied
                      ? Number(paymentDetails.data.request_amount).toFixed(2)
                      : Number(transactionData?.data.request_amount).toFixed(
                          2
                        )}{' '}
                    {transactionData?.data.currency}
                  </div>
                  <div className="success-desc">
                    {transactionData?.data.app.greeting_message
                      ? transactionData?.data.app.greeting_message
                      : 'Thank you for your purchase! Your payment has been successfully processed. You will receive a confirmation email shortly.'}
                  </div>
                  {/* <div className="text-center pt-3 link-success">
                    <a href="https://app.oneid.ink/" target="_blank">
                      Download Receipt
                    </a>{' '}
                  </div> */}
                </div>
              </div>
            )}
          {successDetail &&
            !successDetail.is_pay &&
            successDetail.is_authenticated &&
            successDetail.transaction_id !== '' && (
              <div className="gateway-container2 p-5 d-flex align-items-center">
                <div>
                  <div className="d-flex justify-content-center">
                    <img src={fail} alt="fail" />
                  </div>
                  <div className="success-txt">Payment Failed!</div>
                  <div className="success-amt">
                    {paymentDetails?.data?.discount_applied
                      ? Number(paymentDetails.data.request_amount).toFixed(2)
                      : Number(transactionData?.data.request_amount).toFixed(
                          2
                        )}{' '}
                    {transactionData?.data.currency}
                  </div>
                  <div className="success-desc">
                    We're sorry, but your payment could not be processed at this
                    time. Please check your payment details and try again.
                  </div>
                  {/* <div className="text-center pt-3 link-success">
                    <a href="https://app.oneid.ink/" target="_blank">
                      Download Receipt
                    </a>{' '}
                  </div> */}
                </div>
              </div>
            )}
          {successDetail &&
            !successDetail.is_authenticated &&
            successDetail.transaction_id !== '' && (
              <div className="gateway-container2 p-5 d-flex align-items-center">
                <div>
                  <div className="d-flex justify-content-center">
                    <img src={fail} alt="fail" />
                  </div>
                  <div className="success-txt">Payment Failed!</div>
                  <div className="success-amt">
                    {paymentDetails?.data?.discount_applied
                      ? Number(paymentDetails.data.request_amount).toFixed(2)
                      : Number(transactionData?.data.request_amount).toFixed(
                          2
                        )}{' '}
                    {transactionData?.data.currency}
                  </div>
                  <div className="success-desc">
                    We're sorry, your card is being rejected by the bank.
                  </div>
                  {/* <div className="text-center pt-3 link-success">
                    <a href="https://app.oneid.ink/" target="_blank">
                      Download Receipt
                    </a>{' '}
                  </div> */}
                </div>
              </div>
            )}
        </>
      )}
    </div>
  );
};
